import { useEffect, useState } from 'react';
import { ButtonVariants, SmartButton } from '../../components/buttons/GralButton';
import { DateField } from '../../components/formFields/DateField';
import { TimeField } from '../../components/formFields/TimeField';
import CustomModal from '../../components/modal/CustomModal'
import { Disponibilidad } from '../../data/types/disponibilidad.types'
import { copyJson } from '../../helpers/general.helper';
 
export const DisponibilidadModal = ({
	editDisponibilidad, 
	setEditDisponibilidad,
	onSaveDisponibilidad,
	onDeleteDisponibilidad,
}: {
	editDisponibilidad: Disponibilidad | null,
	setEditDisponibilidad: (disponibilidad: Disponibilidad | null) => void,
	onSaveDisponibilidad: () => void,
	onDeleteDisponibilidad: () => void,
}) => {
	const [errors, setErrors] = useState<Record<string, string | undefined>>({})

	const validateForm = () => {
		const newErrors = errors === undefined ? {} : copyJson(errors)

		if (!editDisponibilidad?.fecha) newErrors.fecha = "La fecha es requerida"
		if (!editDisponibilidad?.horaDesde) newErrors.horaDesde = "La hora de inicio es requerida"
		if (!editDisponibilidad?.horaHasta) newErrors.horaHasta = "La hora de fin es requerida"
		if (editDisponibilidad?.horaDesde! >= editDisponibilidad?.horaHasta!) newErrors.horaHasta = "La hora de fin debe ser mayor a la hora de inicio"

		setErrors(newErrors)

		return Object.keys(newErrors).length === 0
	}

	const handleConfirm = () => {
		if (!validateForm()) return

		onSaveDisponibilidad()
	}

	const handleDelete = () => {
		onDeleteDisponibilidad()
	}

	useEffect(() => {
		console.log("### editDisponibilidad", editDisponibilidad)
		if (!editDisponibilidad) setErrors({})
	}, [editDisponibilidad])
 
	return (
		<CustomModal
			showModal={editDisponibilidad !== null}
			setShowModal={() => setEditDisponibilidad(null)}
			titulo='Disponibilidad'
			width='auto'
			height='auto'
		>
			<h2>{editDisponibilidad?.id ? 'Editar Disponibilidad' : 'Nueva Disponibilidad'}</h2>
			<DateField
				label='Fecha'
				value={editDisponibilidad?.fecha || ''}
				onChange={(value) => {
					if (errors.fecha) setErrors({...errors, fecha: undefined})
					setEditDisponibilidad({...editDisponibilidad, fecha: value} as any)
				}}
				error={errors.fecha}
			/>
			<TimeField
				label='Hora de Inicio'
				allowedMinutes={[0,15,30,45]}
				value={editDisponibilidad?.horaDesde || ''}
				onChange={(value) => {
					if (errors.horaDesde) setErrors({...errors, horaDesde: undefined})
					setEditDisponibilidad({...editDisponibilidad, horaDesde: value} as any)
				}}
				error={errors.horaDesde}
			/>
			<TimeField
				label='Hora de Finalización'
				allowedMinutes={[0,15,30,45]}
				value={editDisponibilidad?.horaHasta || ''}
				onChange={(value) => {
					if (errors.horaHasta) setErrors({...errors, horaHasta: undefined})
					setEditDisponibilidad({...editDisponibilidad, horaHasta: value} as any)
				}}
				error={errors.horaHasta}
			/>
 
		  <div style={{ display: 'flex', justifyContent: 'flex-end', width: '400px'}}>
			  <SmartButton
					variant={ButtonVariants.CANCEL}
					width='90px'
					onClick={() => setEditDisponibilidad(null)}
				>
					Cancelar
			  </SmartButton>
			  {Boolean(editDisponibilidad?.id) && 
				<SmartButton
					variant={ButtonVariants.DELETE}
					width='90px'
					onClick={() => handleDelete()}
					>
					Eliminar
				</SmartButton>
			  }
			  <SmartButton 
				variant={ButtonVariants.CONFIRM}
				width='90px'
				onClick={() => handleConfirm()}
				//   onClick={handleConfirmDelete}
				>
				  {editDisponibilidad?.id ? 'Guardar' : 'Crear'}
			  </SmartButton>
		  </div>
		</CustomModal>
	)
}